import { useState } from 'react';
import { toast } from 'react-toastify';

import config from '@config/index';
import axios, { isAxiosError, AxiosError, AxiosHeaders, AxiosRequestConfig } from 'axios';

import type { IssueRequest } from '@shared/types';


export const API_BASE = '/api';
//ДЛЯ ДЕБАГА НА ТЕЛЕФОНЕ
// не забудь на Амазоне айпи прописать в корсах

// export const API_BASE = 'http://192.168.0.106:3003/api';
// export const API_BASE = 'http://192.168.1.8:3003/api';

axios.defaults.baseURL = getBaseUrl();

interface ApiError {
  message: string;
}

type HandleErrorFn = (message: string, statusCode: number | undefined) => void;

const defaultErrorHandler = (
  message: string,
  statusCode: number | undefined
) => {
  if ((statusCode && statusCode >= 500) || !statusCode) {
    toast.error(message);
  }
};

const useAxios = <Response>(
  handleError: HandleErrorFn = defaultErrorHandler,
) => {
  const [response, setResponse] = useState<Response>();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [statusCode, setStatusCode] = useState<number>();

  const issueRequest: IssueRequest = ({
    url,
    method,
    body,
    headers,
    query,
    responseType,
  }) => {
    setLoading(true);
    
    // Убираем /api из URL, если он уже есть в базовом URL
    // const requestUrl = url.startsWith('/api') ? url : `${API_BASE}${url}`;

    return axios<Response>({
      method,
      url: url,
      data: body,
      headers,
      params: query,
      responseType,
      withCredentials: true,
    })
      .then((res) => {
        console.log('Получен ответ:', { 
          status: res.status,
          data: res.data,
          url: res.config.url,
          method: res.config.method,
          headers: res.config.headers
        });
        setStatusCode(res.status);
        setResponse(res.data);
      })
      .catch((err: Error | AxiosError) => {
        let message;
        let status;

        if (isAxiosError<ApiError>(err)) {
          if (err.response) {
            message = err.response.data.message;
            status = err.response.status;
            setStatusCode(status);
            console.error('Ошибка запроса:', { 
              status,
              message,
              data: err.response.data,
              url: err.config?.url,
              method: err.config?.method,
              headers: err.config?.headers
            });
          } else {
            message = 'Failed to initiate a request. Try again.';
            console.error('Ошибка сети:', message, {
              url: err.config?.url,
              method: err.config?.method
            });
          }
        } else {
          message = err.message;
          console.error('Неизвестная ошибка:', message);
        }

        handleError(message, status);
        setError(message);
      })
      .finally(() => {
        console.log('Запрос завершен');
        setLoading(false);
      });
  };

  return { response, error, issueRequest, loading, statusCode, setLoading };
};

export function getBaseUrl() {
  const { hostname, protocol } = window.location;
  const isLocalhost = hostname === 'localhost';

  const baseUrl = `${protocol}//${hostname}${
    isLocalhost ? `:${config.serverPort}` : ''
  }/api`.trim();

  return baseUrl;
}



export default useAxios;
